import { gql } from "@apollo/client";

export const UpdateSeo = gql`
mutation UpdateSeo($updateSeoId: ID!, $content: contentSeo!) {
  updateSeo(id: $updateSeoId, content: $content) {
    status
  }
}
`;
